import moment from 'moment';

export const INIT_SIGNATURE = {
  signature: '',
  referral_date: moment(),
  is_signature_photo: false,
};

export const MAX_SIGNATURE = 2;
